module.exports = __webpack_public_path__ + "img/do_action_girl.cfaba0bd.png";